import React from 'react'
import {useOptimizelyPage} from '../../hooks/use-optimizely-page'
import {renderLayoutsSwitch} from '../../components/optimizely/utils/contentRenderer'
import {WISHLIST_EMPTY_PAGE_ID} from './wishlist-empty'

const WishlistNoCollections = () => {
    const {data: optimizelyData} = useOptimizelyPage(WISHLIST_EMPTY_PAGE_ID)

    const pageContent = optimizelyData?.item || optimizelyData?.items?.[0]
    const noCollections = pageContent?.NoCollectionsContentTile ?? []

    if (noCollections.length === 0) {
        return null
    }

    return (
        <>
            {noCollections.map((item, idx) => (
                <React.Fragment key={`${item?.ContentLink?.Id ?? 'no-collections'}-${idx}`}>
                    {renderLayoutsSwitch(item?.ContentLink?.Expanded)}
                </React.Fragment>
            ))}
        </>
    )
}

export default WishlistNoCollections
